import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import { steps } from "./staticData";
import HowDoesItWork from "./Steps/HowDoesItWork";
import EnterZipStep from "./Steps/EnterZipStep";
import classnames from "classnames";

const MAX_SWIPE_DISTANCE = 30;

const LocationBarSlider = ({
  texts,
  toggle,
  isZipModalOpen,
  currentStep,
  onSubmit,
  values,
  changeHandler,
  errors,
  isProcessing,
  additionalStepClickHandler,
  openDialog,
}) => {
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)

  const onTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientY);
    setTouchEnd(null);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchEnd - touchStart;

    if (touchStart < touchEnd && distance >= MAX_SWIPE_DISTANCE) {
      toggle();
    }
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientY)

  return (
    <Modal
      className="tw-relative"
      style={{
        width: "100%",
      }}
      open={isZipModalOpen}
      onClose={toggle}
      TransitionComponent={Slide}
      transitionDuration={600}
    >
      <Slide direction="up" in={isZipModalOpen} mountOnEnter unmountOnExit>
        <div
          onTouchMove={onTouchMove}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
          className="tw-bg-white tw-overflow-hidden tw-fixed tw-bottom-0 tw-left-0 tw-pb-8 tw-w-full"
          style={{
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        >
          <div style={{ overflowY: "auto", position: "relative" }}>
            <div
              style={{
                position: "absolute",
                right: "20px",
                top: "13px",
              }}
            >
              <IconButton
                color="inherit"
                onClick={toggle}
                className="paddingMarginRemover"
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div>
              {currentStep === steps.zipCodeStep && (
                <div
                  style={{
                    backgroundImage: "url(/bitmap_map.svg)",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                  className="tw-flex tw-justify-center tw-mb-10 tw-h-64"
                >
                  <img
                    className=" tw-w-32"
                    src="/bitmap_icon.svg"
                    alt="location_icon"
                  />
                </div>
              )}

              <div
                className={classnames("tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-5", {
                  "tw-pt-12": currentStep !== steps.zipCodeStep,
                })}
              >
                {currentStep === steps.howDoesItWork ? (
                  <HowDoesItWork returnFunc={additionalStepClickHandler} />
                ) : (
                  <EnterZipStep
                    changeHandler={changeHandler}
                    isProcessing={isProcessing}
                    additionalStepClickHandler={additionalStepClickHandler}
                    onSubmit={onSubmit}
                    errors={errors}
                    currentStep={currentStep}
                    values={values}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Slide>
    </Modal>
  );
};

export default LocationBarSlider;
